export const NFT_POPUP_TYPE = {
  info: 'info',
  mint: 'mint',
  funds: 'funds',
  cashApp: 'cashApp'
}
